import React, { Component } from 'react'
import {
  Button,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Tooltip,
  Menu,
  ButtonBase,
  Input,
} from '@material-ui/core'

// utils
import { onChangeEditHOF, toCurrencyLocale } from '../../utils/common'
import { isValidCurrencyInput } from '../../utils/validations/common'
import { hasAccess } from '../../utils/api'
import { checkoutTypes } from '../../utils/constants'

import {
  EditableTextField,
  EditableSwitch,
  EditableSelect,
  EditableReactSelect,
} from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import { connect } from 'react-redux'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { openErrorMessage } from '../../actions/message'

const terminalTypes = [
  { name: 'NotAssigned', displayName: 'Not Specified' },
  { name: 'WalkIn', displayName: 'Store' },
  { name: 'Delivery', displayName: 'Delivery' },
  { name: 'Event', displayName: 'Event' },
]

class ShopTerminalItem extends Component {
  constructor(props) {
    super(props)
    // this.state = {
    //     availableInventories:[]
    // }
    this.state = {
      anchorEl: null,
      selectedBrands: (this.props.data && this.props.data.brandIds) || [],
      quickStartAmount: this.props.quickStartAmount || 0,
    }

    this.openRegionModal = this.openRegionModal.bind(this)
    this.closeRegionModal = this.closeRegionModal.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quickStartAmount !== this.props.quickStartAmount && !this.props.editMode) {
      this.setState({ quickStartAmount: this.props.quickStartAmount || 0 })
    }
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      this.props.onChange(key, isCheckBox ? event.target.checked : event.target.value)
      if (key == 'regionId') {
        this.props.onChange('assignedInventoryId', '')
      }
      this.props.refreshValidationList &&
        this.props.refreshValidationList(
          this.props.data.id,
          key,
          isCheckBox ? event.target.checked : event.target.value,
        )
    }

  onSave = () => {
    const quickStartAmount = parseFloat(this.state.quickStartAmount) || 0
    this.props.onChange('quickStartAmount', quickStartAmount, () => {
      this.props.onSave((response) => this.props.disableEdit())
    })
  }

  onCancel = () => {
    this.setState({
      selectedBrands:
        (this.props.data &&
          this.props.data.brands &&
          this.props.data.brands.map((brand) => brand.id)) ||
        [],
      quickStartAmount: this.props.quickStartAmount || 0,
    })

    this.props.onCancel()
  }

  getInventoriesByRegion(data, inventories = [], terminals = []) {
    var availableInventories = inventories.filter((inventory) => {
      var regionExists = inventory.regionIds && inventory.regionIds.includes(data.regionId)
      return regionExists ? inventory : false
    })

    // terminals.map(terminal => {
    //     if(terminal.id!=data.id && terminal.regionId && terminal.regionId==data.regionId){
    //         availableInventories = availableInventories.filter(inventory => inventory.id!=terminal.assignedInventoryId);
    //     }
    // });

    return availableInventories
  }

  checkInventoriesByRegion(regionId, terminalId, inventories = [], terminals = []) {
    var availableInventories = inventories.filter((inventory) => {
      var regionExists = inventory.regionIds && inventory.regionIds.includes(regionId)
      return regionExists ? inventory : false
    })

    // terminals.map(terminal => {
    //     if(terminal.id!=terminalId && terminal.regionId && terminal.regionId==regionId){
    //         availableInventories = availableInventories.filter(inventory => inventory.id!=terminal.assignedInventoryId);
    //     }
    // });

    return availableInventories.length > 0 ? false : true
  }

  openRegionModal(event) {
    this.setState({
      anchorEl: event.currentTarget,
    })
  }

  closeRegionModal(region) {
    this.setState({
      anchorEl: null,
    })
    if (region !== null && region.id) {
      this.props.onChange('regionId', region.id)
      this.props.onChange('assignedInventoryId', '')
      this.props.refreshValidationList &&
        this.props.refreshValidationList(this.props.data.id, 'regionId', region.id)
      this.props.refreshValidationList &&
        this.props.refreshValidationList(this.props.data.id, 'assignedInventoryId', '')
    }
  }

  onChangeBrands = (inputBrands) => {
    const allBrands =
      (this.props.inventoryReducer &&
        this.props.inventoryReducer.brands &&
        this.props.inventoryReducer.brands.values) ||
      []
    let returnBrand = []

    inputBrands.forEach((inputBrand) => {
      const foundBrand = allBrands.find((brand) => brand.id == inputBrand.value)
      if (foundBrand) {
        returnBrand.push(foundBrand.id)
      }
    })

    this.props.onChange('brandIds', returnBrand)
    this.setState({
      selectedBrands: returnBrand,
    })
  }

  render() {
    const {
      data,
      editMode,
      inventories,
      thirdPartyAccounts,
      blazePayPermission,
      posTerminals,
      validationList,
      eventLedgerEnabled,
      drawerQuickStartEnabled,
    } = this.props

    const { regions = {}, terminals = {}, companyFeatures = {} } = this.props.companyReducer
    const { session = {} } = this.props.authReducer
    const { availableApps = [] } = companyFeatures
    const dispatchActive =
      availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0

    const selectedInventory = inventories.find((shop) => shop.id == data.assignedInventoryId) || {}
    const selectedThirdPartyAccount = thirdPartyAccounts.find(
      (account) => account.id == data.cvAccountId,
    ) || { name: 'None' }
    const selectedPosTerminal = (posTerminals &&
      posTerminals.length > 0 &&
      posTerminals.find((posTerminal) => posTerminal.id == data.posTerminal)) || { name: '' }
    const permitted = hasAccess()
    const regionsValues = (regions && regions.values) || []
    const SelectedNameRegion = regionsValues.find((region) => region.id == data.regionId) || {}
    const availableInventories =
      dispatchActive && SelectedNameRegion && SelectedNameRegion.name
        ? this.getInventoriesByRegion(data, inventories, validationList)
        : inventories

    const blazeEventsEnabled =
      this.props.companyReducer &&
      this.props.companyReducer.companyFeatures &&
      this.props.companyReducer.companyFeatures.blazeEvent

    const availableTerminalTypes = terminalTypes.filter(
      (terminalType) => terminalType.name !== 'Event' || eventLedgerEnabled,
    )

    const brands =
      (this.props.inventoryReducer &&
        this.props.inventoryReducer.brands &&
        this.props.inventoryReducer.brands.values) ||
      []

    const selectedTerminalType =
      availableTerminalTypes.find((termType) => data.terminalType == termType.name) ||
      availableTerminalTypes[0]
    console.log('selected term type', selectedTerminalType)

    let brandsToRender = []

    if (brands.length && this.state.selectedBrands.length) {
      this.state.selectedBrands.forEach((inputBrand) => {
        let foundBrand = brands.find((brand) => brand.id == inputBrand)
        if (foundBrand) {
          brandsToRender.push(foundBrand.name)
        }
      })
    }

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">{data.id}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">{data.deviceName}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.terminalType}
            onChange={this.onChange('terminalType')}
            valueToRender={selectedTerminalType && selectedTerminalType.displayName}
            //valueToRender={this.inventoriesSelect(data.assignedInventoryId)}
            editMode={editMode}
          >
            {availableTerminalTypes &&
              availableTerminalTypes.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.name}>
                    {item.displayName}
                  </MenuItem>
                )
              })}
          </EditableSelect>
        </TableCell>
        {dispatchActive ? (
          <TableCell>
            {editMode ? (
              <ButtonBase
                onClick={(e) => {
                  this.openRegionModal(e)
                }}
                style={{ borderBottom: '1px solid' }}
              >
                <div
                  style={{
                    width: '120px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '4px',
                  }}
                >
                  {SelectedNameRegion.name}
                </div>
                <ArrowDropDownIcon />
              </ButtonBase>
            ) : (
              <div>{SelectedNameRegion.name}</div>
            )}

            <Menu
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={this.closeRegionModal}
            >
              {regionsValues &&
                regionsValues.map((region, index) => {
                  let disabled = this.checkInventoriesByRegion(
                    region.id,
                    data.id,
                    inventories,
                    validationList,
                  )
                  return (
                    <Tooltip title={disabled ? 'Region must be assigned to an Inventory' : ''}>
                      <div>
                        <MenuItem
                          disabled={disabled}
                          key={index}
                          onClick={() => {
                            !disabled && this.closeRegionModal(region)
                          }}
                        >
                          {region.name}
                        </MenuItem>
                      </div>
                    </Tooltip>
                  )
                })}
            </Menu>
          </TableCell>
        ) : null}
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.assignedInventoryId}
            onChange={this.onChange('assignedInventoryId')}
            valueToRender={selectedInventory && selectedInventory.name}
            //valueToRender={this.inventoriesSelect(data.assignedInventoryId)}
            editMode={editMode}
          >
            {availableInventories &&
              availableInventories.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.name}
                  </MenuItem>
                )
              })}
          </EditableSelect>
        </TableCell>
        {
          <TableCell className="cell-wrap-word">
            <EditableSelect
              value={
                data.checkoutType == ''
                  ? session.assignedShop && session.assignedShop.checkoutType
                  : data.checkoutType
              }
              onChange={this.onChange('checkoutType')}
              valueToRender={data.checkoutType}
              editMode={editMode}
            >
              {checkoutTypes.map((checkoutType, index) => {
                return (
                  <MenuItem key={index} value={checkoutType.value}>
                    {checkoutType.label}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          </TableCell>
        }
        {blazePayPermission && blazePayPermission.enabled && (
          <TableCell className="cell-wrap-word">
            <EditableSelect
              value={data.posTerminal}
              onChange={this.onChange('posTerminal')}
              valueToRender={selectedPosTerminal.name}
              editMode={editMode}
            >
              <MenuItem value={''}> Select a POS Terminal </MenuItem>
              {posTerminals.map((posTerminal, index) => {
                return (
                  <MenuItem key={index} value={posTerminal.id}>
                    {posTerminal.name}
                  </MenuItem>
                )
              })}
            </EditableSelect>
          </TableCell>
        )}
        {blazeEventsEnabled ? (
          <TableCell className="cell-wrap-word">
            <EditableReactSelect
              multi={true}
              valueToRender={brandsToRender.join(', ')}
              editMode={editMode}
              value={this.state.selectedBrands}
              type="text"
              options={brands.map((brand) => ({ label: brand.name, value: brand.id }))}
              onChange={this.onChangeBrands}
              InputLabelProps={{
                shrink: false,
              }}
            />
          </TableCell>
        ) : null}

        {drawerQuickStartEnabled ? (
          <TableCell className="cell-wrap-word">
            {editMode ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: 4, fontSize: 14 }}>$</span>
                <Input
                  value={this.state.quickStartAmount}
                  onChange={(e) => {
                    const value = e.target.value
                    if (isValidCurrencyInput(value)) {
                      this.setState({ quickStartAmount: value })
                    }
                  }}
                  type="number"
                  inputProps={{ min: 0, step: 0.01 }}
                  className="no-spinner"
                  style={{ width: 80 }}
                />
              </div>
            ) : (
              <span>{toCurrencyLocale(this.state.quickStartAmount)}</span>
            )}
          </TableCell>
        ) : null}

        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.active ? 'Active' : 'Inactive'}
            checked={data.active}
            editMode={editMode}
            onChange={this.onChange('active', true)}
          />
        </TableCell>

        {permitted ? (
          <TableCell className="cell-wrap-word terminal-actions">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={(e) => {
                let regionList = this.state.regionList || (regions && regions.values) || []
                this.props.enableEdit(e)

                const regionList1 = regionList.map((region) => {
                  return {
                    ...region,
                    disabled: this.checkInventoriesByRegion(
                      region.id,
                      data.id,
                      inventories,
                      validationList,
                    ),
                  }
                })

                this.setState({
                  regionsList: regionList1,
                })
              }}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}

export default connect(({ dispatch, companyReducer, inventoryReducer, authReducer }) => ({
  dispatch,
  companyReducer,
  inventoryReducer,
  authReducer,
}))(ShopTerminalItem)



// WEBPACK FOOTER //
// ./src/components/Terminals/ShopTerminalItem.js